import React, {useEffect, useState} from 'react';
import Welcome from "./components/welcome";
import Diagnoses from "./components/diagnoses";
import Helps1 from "./components/helps1";
import Helps2 from "./components/helps2";
import Helps3 from "./components/helps3";
import Helps4 from "./components/helps4";
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import {Provider} from "react-redux";
import {store, validateStoreFields} from "./store";
import SignUp from "./components/signup";
import Login from "./components/login";
import PrepareApp from "./components/prepareApp";
import LearnAboutUs from "./components/learnAboutUs";
import AppHeader from "./components/appHeader";
import TellUsAboutYou from "./components/tellUsAboutYou";
import ThanksWantToHearMore from "./components/thanksWantToHearMore";
import Frustrations from "./components/frustrations";
import VerifyItsYou from "./components/verifyItsYou";
import Claims from "./components/claims";
import WouldYouMind from "./components/wouldYouMind";
import HealthPlanDetails from "./components/healthPlanDetails";
import DisposableIncome from "./components/disposableIncome";
import Plan from "./components/plan";
import AdditionalInfo from "./components/additionalInfo";
import Review from "./components/review";
import Success from "./components/success";
import Summary from "./components/summary";
import ConditionDetails from "./components/conditionDetails";
import AlsoIncludes from "./components/alsoIncludes";
import StandaloneOnlyRoute from "./components/standaloneOnlyRoute";
import ThanksDeclined from "./components/thanksDeclined";
import SummaryReturningUser from "./components/summaryReturningUser";
import Unsubscribe from "./components/unsubscribe";
import UnsubscribeSuccess from "./components/unsubscribeSuccess";
import {
    ADDITIONAL_INFO_ROUTE,
    CLAIMS_ROUTE,
    CONDITIONS_ROUTE,
    COVERAGE_DECLINED_PATH,
    ELIGIBILITY_LOSS,
    EXPIRED_ROUTE,
    FORGOT_PASSWORD,
    FRUSTRATIONS_ROUTE,
    HEALTH_PLAN_DETAILS_ROUTE,
    INCOME_ROUTE,
    isAIG,
    isAnsel,
    isDistributionChannelIndividual,
    isRenaissance,
    isSymetra,
    LEARN_ABOUT_COVERAGE_ROUTE,
    LINK_EXPIRED_ROUTE,
    NO_CONTRACT_TO_ENROL,
    NOT_IN_OPEN_ENROLLMENT_ROUTE,
    PASSWORD_RESET_REQUEST_SENT,
    PLAN_PAYS_ROUTE,
    PLUS_ROUTE,
    REQUEST_SENT_ROUTE,
    RESET_PASSWORD,
    REVIEW_ROUTE,
    SELECT_PLAN_ROUTE,
    SUCCESS_ROUTE,
    SUMMARY_RETURNING_ROUTE,
    SUMMARY_ROUTE,
    TELL_US_ABOUT_YOU_ROUTE,
    VERIFY_ITS_YOU_ROUTE,
    WHY_ROUTE,
    WOULD_YOU_MIND_ROUTE
} from "./utils/common";
import ScrollToTop from "./components/scrollToTop";
import NoOENoElections from "./components/noOENoElections";
import ExpiredToken from "./components/expiredToken";
import RequestSent from "./components/requestSent";
import RecordNavigation from "./components/recordNavigation";
import ForgotPassword from "./components/forgotPassword";
import ResetPassword from "./components/resetPassword";
import EnrollmentIssue from './components/enrollmentIssue';
import PasswordResetRequestSent from "./components/passwordResetRequestSent";
import WhyUs from "./components/whyUs";
import HowYourPlanPays from "./components/howYourPlanPays";
import StripeWrapper from "./components/stripeWrapper";
import NotEligible from "./components/notEligible";
import LinkExpired from "./components/linkExpired";
import {axiosInit} from './utils/axios';
import useApp from "./hooks/useApp";

import './app.css';

import Toasts from "./components/toasts/toasts";


axiosInit();

const getBasename = () => {
    return window.location.pathname.startsWith('/enrollment') ? '/enrollment' : '';
};

const App = () => {
    const [displayPlus, setDisplayPlus] = useState(true);

    useApp();

    useEffect(()=>{
        validateStoreFields();

    }, []);

    const setHidePlusRoute = (displayPlusRoute) => {
        setDisplayPlus(displayPlusRoute);
    };


    const isIndividual = () => isDistributionChannelIndividual(store.getState().initialData.distributionChannel);
    const brellaPaysNext = displayPlus ? PLUS_ROUTE : CLAIMS_ROUTE;
    const claimsPrev = displayPlus ? PLUS_ROUTE : PLAN_PAYS_ROUTE;
    const p = window.location.pathname;
    const backgroundClass = (p === EXPIRED_ROUTE || p === REQUEST_SENT_ROUTE) ? "bkgNeutral50" : "bkgWhite"

        return (
            <Provider store={store}>
                <PrepareApp setHidePlusRoute={setHidePlusRoute} displayPlusStatus={displayPlus}>
                    <BrowserRouter basename={getBasename()}>
                        <div className={`enrollment-main-container ${backgroundClass} ${(isAnsel() || isSymetra() || isAIG() || isRenaissance())  && 'enrollment-main-container-padding'}`}>
                            <AppHeader/>
                            <ScrollToTop/>
                            <RecordNavigation>
                                <Switch>
                                    <Route exact path="/" render={() => <Welcome nextRoute={isIndividual() ? LEARN_ABOUT_COVERAGE_ROUTE : VERIFY_ITS_YOU_ROUTE}/>}/>
                                    <Route exact path={VERIFY_ITS_YOU_ROUTE} render={() => isIndividual() ? <Redirect to={LEARN_ABOUT_COVERAGE_ROUTE}/> : <VerifyItsYou prevRoute={'/'} nextRoute={LEARN_ABOUT_COVERAGE_ROUTE}/>}/>
                                    <Route exact path={LEARN_ABOUT_COVERAGE_ROUTE} render={() => <LearnAboutUs prevRoute={isIndividual() ? '/' : VERIFY_ITS_YOU_ROUTE} nextRoute={isIndividual() ? WHY_ROUTE : TELL_US_ABOUT_YOU_ROUTE}/>}/>
                                    <Route exact path={TELL_US_ABOUT_YOU_ROUTE} render={() => isIndividual() ? <Redirect to={WHY_ROUTE}/> : <TellUsAboutYou prevRoute={LEARN_ABOUT_COVERAGE_ROUTE} nextRoute={"/thanks"}/>}/>
                                    <Route exact path="/thanks" render={() => isIndividual() ? <Redirect to={WHY_ROUTE}/> : <ThanksWantToHearMore prevRoute={TELL_US_ABOUT_YOU_ROUTE} nextRoute={WHY_ROUTE}/>}/>
                                    <Route exact path={WHY_ROUTE} render={() => <WhyUs prevRoute={isIndividual() ? LEARN_ABOUT_COVERAGE_ROUTE : '/thanks'} nextRoute={FRUSTRATIONS_ROUTE}/>}/>
                                    <Route exact path={FRUSTRATIONS_ROUTE} render={() => <Frustrations prevRoute={WHY_ROUTE} nextRoute={"/diagnoses"}/>}/>
                                    <Route exact path="/diagnoses" render={() => <Diagnoses prevRoute={FRUSTRATIONS_ROUTE} nextRoute={CONDITIONS_ROUTE}/>}/>
                                    <Route exact path={CONDITIONS_ROUTE} render={() => <ConditionDetails prevRoute={'/diagnoses'} nextRoute={PLAN_PAYS_ROUTE}/>}/>
                                    <Route exact path={PLAN_PAYS_ROUTE} render={() => <HowYourPlanPays prevRoute={CONDITIONS_ROUTE} nextRoute={brellaPaysNext}/>}/>
                                    <Route exact path={PLAN_PAYS_ROUTE + "/1"} render={() => <Helps1 prevRoute={PLAN_PAYS_ROUTE} nextRoute={PLAN_PAYS_ROUTE}/>}/>
                                    <Route exact path={PLAN_PAYS_ROUTE + "/2"} render={() => <Helps2 prevRoute={PLAN_PAYS_ROUTE} nextRoute={PLAN_PAYS_ROUTE}/>}/>
                                    <Route exact path={PLAN_PAYS_ROUTE + "/3"} render={() => <Helps3 prevRoute={PLAN_PAYS_ROUTE} nextRoute={PLAN_PAYS_ROUTE}/>}/>
                                    <Route exact path={PLAN_PAYS_ROUTE + "/4"} render={() => <Helps4 prevRoute={PLAN_PAYS_ROUTE} nextRoute={PLAN_PAYS_ROUTE}/>}/>
                                    {displayPlus && <Route exact path={PLUS_ROUTE} render={() => <AlsoIncludes prevRoute={PLAN_PAYS_ROUTE} nextRoute={CLAIMS_ROUTE}/>}/>}
                                    <Route exact path={CLAIMS_ROUTE} render={() => <Claims prevRoute={claimsPrev} nextRoute={isIndividual() ? SUCCESS_ROUTE : WOULD_YOU_MIND_ROUTE}/>}/>
                                    <Route exact path={WOULD_YOU_MIND_ROUTE} render={() => <WouldYouMind prevRoute={CLAIMS_ROUTE} nextRoute={HEALTH_PLAN_DETAILS_ROUTE}/>}/>
                                    <Route exact path={HEALTH_PLAN_DETAILS_ROUTE} render={() => <HealthPlanDetails prevRoute={WOULD_YOU_MIND_ROUTE} nextRoute={INCOME_ROUTE}/>}/>
                                    <Route exact path={INCOME_ROUTE} render={() => <DisposableIncome prevRoute={HEALTH_PLAN_DETAILS_ROUTE} nextRoute={SELECT_PLAN_ROUTE}/>}/>
                                    <Route exact path={SELECT_PLAN_ROUTE} render={() => <Plan prevRoute={INCOME_ROUTE} nextRoute={SUMMARY_ROUTE}/>}/>

                                    <Route exact path={ELIGIBILITY_LOSS} render={() => <NotEligible/>}/>
                                    <Route exact path={LINK_EXPIRED_ROUTE} render={() => <LinkExpired/>}/>

                                    <StandaloneOnlyRoute exact path={SUMMARY_ROUTE} render={() => <Summary prevRoute={SELECT_PLAN_ROUTE} nextRoute={ADDITIONAL_INFO_ROUTE}/>}/>
                                    <StandaloneOnlyRoute exact path={ADDITIONAL_INFO_ROUTE} render={() => <AdditionalInfo prevRoute={SUMMARY_ROUTE} nextRoute={REVIEW_ROUTE}/>}/>
                                    <StandaloneOnlyRoute exact path={REVIEW_ROUTE}
                                                         render={() => (<StripeWrapper prevRoute={ADDITIONAL_INFO_ROUTE} nextRoute={SUCCESS_ROUTE} component={Review}/>)}/>
                                    <StandaloneOnlyRoute exact path={SUCCESS_ROUTE} allowIndividual render={() => <Success prevRoute={isIndividual() ? CLAIMS_ROUTE : REVIEW_ROUTE} nextRoute={"/"}/>}/>
                                    <StandaloneOnlyRoute exact path={SUMMARY_RETURNING_ROUTE} render={() => <SummaryReturningUser/>}/>
                                    <StandaloneOnlyRoute exact path={COVERAGE_DECLINED_PATH} render={() => <ThanksDeclined/>}/>
                                    <StandaloneOnlyRoute exact path="/signUp" render={() => <SignUp/>}/>
                                    <StandaloneOnlyRoute exact path="/login" render={() => <Login/>}/>
                                    <Route exact path={NOT_IN_OPEN_ENROLLMENT_ROUTE} render={() => <NoOENoElections/>}/>
                                    <Route exact path={NO_CONTRACT_TO_ENROL} render={() => <EnrollmentIssue/>}/>
                                    <Route exact path="/unsubscribe" render={() => <Unsubscribe/>}/>
                                    <Route exact path="/unsubscribeSuccess" render={() => <UnsubscribeSuccess/>}/>


                                    <Route exact path={EXPIRED_ROUTE} render={() => <ExpiredToken/>}/>
                                    <Route exact path={REQUEST_SENT_ROUTE} render={() => <RequestSent/>}/>

                                    <Route exact path={FORGOT_PASSWORD} render={() => <ForgotPassword/>}/>
                                    <Route exact path={PASSWORD_RESET_REQUEST_SENT} render={() => <PasswordResetRequestSent/>}/>
                                    <Route path={RESET_PASSWORD} render={() => <ResetPassword/>}/>

                                    <Route render={() => {
                                        return <Redirect to={"/"}/>;
                                    }}/>
                                </Switch>
                            </RecordNavigation>
                        </div>
                    </BrowserRouter>
                </PrepareApp>
                <Toasts/>
            </Provider>
        )
    }

export default App;
